import type { ReactNode } from "react";

export default function PreviewItem({
  label,
  value,
}: {
  label: string;
  value: ReactNode;
}) {
  return (
    <div className="flex justify-between py-2.5 -mx-4 px-4 border-b border-black-200">
      <span className="text-black-500 text-button-sm">{label}</span>
      {value}
    </div>
  );
}
